import { defineComponent } from "vue";
import { usePortalStore } from "@/framework/portal";
import CircularProgress from "@/plugins/circular-progress/circular-progress.vue";
import _ from "lodash";

export default defineComponent ({
    name: "ConfirmPage",
    inheritAttrs: false,
    components: {
        CircularProgress,
    },
    props: {
        title: {
            type: String,
            required: true
        },
        description: {
            type: String,
            required: false
        },
        visitDetails: {
            type: Object,
            required: true
        },
        fields: {
            type: Array as () => Array<any>,
            required: true
        },
        inductions: {
            type: Array as () => Array<any>,
            required: false
        }
    },
    setup() {
        const portal = usePortalStore();
        const groups = portal.getConfirmGroups(portal.fields);
        
        return {
            portal,
            groups
        };
    },
    data() {
        return {
            displayedFields: [] as any[]
        }
    },
    created() {
        if (this.fields.length) {
            this.displayedFields = _.filter(this.fields, fld => {
                return fld.showOnConfirm;
            });
        }
    }
});